import React from 'react';
import { X } from 'lucide-react';
import { AIRecommendationPanel } from './AIRecommendationPanel';
interface Recommendation {
  id: string;
  title: string;
  type: string;
  diamondRange: string;
  reason: string;
  ctaLabel: string;
  onCtaClick: () => void;
}
interface WidgetAISidebarProps {
  isOpen: boolean;
  onClose: () => void;
  widgetInfo: {
    title: string;
    description: string;
  };
  recommendations: Recommendation[];
}
export const WidgetAISidebar: React.FC<WidgetAISidebarProps> = ({
  isOpen,
  onClose,
  widgetInfo,
  recommendations
}) => {
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-141" />

      {/* Drawer - Same style as AISidebar */}
      <aside className="fixed top-0 right-0 h-full w-full sm:w-[400px] bg-white shadow-xl z-50 overflow-y-auto transform transition-transform duration-300" data-id="element-142">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex items-center justify-between z-10" data-id="element-143">
          <h2 className="text-base font-semibold text-gray-900" data-id="element-144">
            {widgetInfo.title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-145">
            <X className="h-5 w-5 text-gray-500" data-id="element-146" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4" data-id="element-147">
          {widgetInfo.description && <p className="text-sm text-gray-600 mb-4" data-id="element-148">
              {widgetInfo.description}
            </p>}

          {/* Use AIRecommendationPanel for consistent styling */}
          <AIRecommendationPanel recommendations={recommendations} lastUpdated="Ultimi 30 giorni" data-id="element-149" />
        </div>
      </aside>
    </>;
};